<template>
  <div id="example-container" class="wrapper">
    <h2>Film Lists</h2>
    <div class="list-wrap pure-g">
      <div class="pure-u-1-4 list-actions">
        <div class="pure-form pure-form-stacked">
          <div class="input-field">
            <input name="new_list" placeholder="New list" id="new_list" type="text" class="validate tooltip" v-model="newListName" autocomplete="off" v-on:keyup.enter="createList">
            <div v-on:click="createList" class="add-list-trigger"><i class="fal fa-plus-circle"></i><i class="fas fa-circle-notch fa-spin"></i></div>
          </div>
        </div>
        <div class="pure-form pure-form-stacked">
          <label>List select</label>
          <select name="list_select" id="list_select" v-on:change="listChange()">
            <option v-for="list in lists" :value="list.id">{{list.name}}</option>
          </select>
        </div>
        <h4>Film results</h4>
        <ais-index app-id="EQ4MPZHE99" api-key="b883b4278df4fd23853990e7ed74551d" index-name="movies">
          <ais-search-box></ais-search-box>
          <ais-results>
            <template slot-scope="{ result }">
              <div class="grape-result" :data-id="result.objectID" v-on:click="addFilmToCurrentList(result.objectID)">
                <ais-highlight :result="result" attribute-name="Title"></ais-highlight>
                <div class="director">{{result.Director}}</div>
                <div class="year">{{result.Year}}</div>
              </div>
            </template>
          </ais-results>
        </ais-index>
      </div>
      <div class="pure-u-3-4 grape-results">
        <div class="table-wrap">
          <HotTable :root="root" ref="filmsTable" :settings="hotSettings" :onAfterRowMove="afterRowMoveHandler"></HotTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $, algoliasearch */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from './firebaseInit'

  export default {
    data: function () {
      return {
        root: 'matrix-table',
        currentUserID: null,
        currentList: null,
        films: [],
        filmIDs: [],
        lists: [],
        mailchimpLists: [],
        newListName: null,
        isAddingList: false,
        grapesQuery: '',
        searchLimit: 200,
        pageLimit: 5000,
        hotSettings: {
          data: this.grapes,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Quality', 'Title', 'Director', 'Year', 'Plot', 'RTConsensus', 'Genre', 'Cast', 'Language', 'Production', 'Poster', 'RTUserReviews', 'RTUser35', 'imdbVotes', 'imdb35', 'letterboxdVotes', 'RTCriticReviews', 'RTCrit35', 'Buzz', 'StatNumber', 'statPercentile', 'Stat30', 'Stat100', 'RTCriticMeter', 'RTUserMeter', 'imdb10', 'LetterboxdScore', 'Metacritic', 'Remove'],
          rowHeights: 50,
          colWidths: [100, 80, 120, 120, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 200],
          columns: [
            {data: 'docID', readOnly: true},
            {data: 'Quality', type: 'numeric'},
            {data: 'Title', type: 'text'},
            {data: 'Director', type: 'text'},
            {data: 'Year', type: 'numeric'},
            {data: 'Plot', type: 'text'},
            {data: 'RTConsensus', type: 'text'},
            {data: 'Genre', type: 'text'},
            {data: 'Cast', type: 'text'},
            {data: 'Language', type: 'text'},
            {data: 'Production', type: 'text'},
            {data: 'Poster', type: 'text'},
            {data: 'RTUserReviews', type: 'numeric'},
            {data: 'RTUser35', type: 'numeric'},
            {data: 'imdbVotes', type: 'numeric'},
            {data: 'imdb35', type: 'numeric'},
            {data: 'letterboxdVotes', type: 'numeric'},
            {data: 'RTCriticReviews', type: 'numeric'},
            {data: 'RTCrit35', type: 'numeric'},
            {data: 'Buzz', type: 'numeric'},
            {data: 'StatNumber', type: 'numeric'},
            {data: 'statPercentile', type: 'numeric'},
            {data: 'Stat30', type: 'numeric'},
            {data: 'Stat100', type: 'numeric'},
            {data: 'RTCriticMeter', type: 'numeric'},
            {data: 'RTUserMeter', type: 'numeric'},
            {data: 'imdb10', type: 'numeric'},
            {data: 'LetterboxdScore', type: 'numeric'},
            {data: 'Metacritic', type: 'numeric'},
            {data: 'remove', renderer: 'html'}
          ]
        }
      }
    },
    name: 'filmList',
    components: {
      HotTable
    },
    created () {
      let vm = this
      vm.showLoading()
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          vm.currentUserID = user.uid
          vm.getLists()
          vm.getFilms()          
        }
      })
      vm.getLists()
      vm.getFilms()
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      createList: function () {
        let vm = this
        if (this.newListName && this.newListName.length < 3) {
          return
        }
        if (!vm.isAddingList && this.newListName.length >= 3) {
          vm.isAddingList = true
          let listName = this.newListName
          let userID = this.currentUserID
          $('#new_list').prop('disabled', true)
          $('.add-list-trigger').addClass('is-adding')
          let listData = {
            'name': listName,
            'userID': userID,
            'films': [],
            'createdTimestamp': firebase.firestore.FieldValue.serverTimestamp()
          }
          mixpanel.track(
            'Created list',
            {
              'listName': listName
            }
          )
          db.collection('lists').add(listData).then(function (docRef) {
            console.log('Document written with ID: ', docRef.id)
            vm.newListName = ''
            vm.getLists()
            setTimeout(function () {
              vm.isAddingList = false
              $('#new_list').prop('disabled', false)
              $('.add-list-trigger').removeClass('is-adding')
            }, 500)
          })
        }
      },
      getLists: function () {
        let vm = this
        var listsRef = db.collection('lists')
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              vm.lists.push(listData)
            }
          })
          setTimeout(function () {
            vm.hideLoading()
            vm.listChange()
          }, 2000)
        })
      },
      listChange: function () {
        let vm = this
        let $listID = $('#list_select').val()
        console.log('list changed: ' + $listID)
        vm.filmIDs = []
        vm.films = []
        // vm.$refs.filmsTable.table.loadData(vm.films)
        var listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          console.log(doc.id, ' => ', doc.data())
          vm.filmIDs = doc.data().films
          vm.getFilms()
        })
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].docID === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
      getFilms: function () {
        console.log('getting list movies')
        let vm = this
        let regex = /\s+/gi
        console.log(vm.filmIDs)
        if (!vm.$refs.filmsTable) {
          return;
        }
        if (vm.filmIDs === undefined || vm.filmIDs.length == 0) {
          vm.$refs.filmsTable.table.loadData(vm.films)
        } else {
          vm.filmIDs.forEach(filmID => {
            var filmRef = db.collection('movies').doc(filmID)
            filmRef.get().then(function (doc) {
              var movieData = doc.data()
              movieData.docID = doc.id
              movieData.remove = '<a href="#" data-id="' + doc.id + '" class="remove-film">Remove</a>'
              console.log(vm.films)
              console.log(movieData.docID)
              if (!vm.checkPresentInArray(vm.films, movieData.docID, true)) {          
                vm.films.push(movieData)
              }
              /* Load Data */
              vm.$refs.filmsTable.table.loadData(vm.films)
              setTimeout(function () {
                vm.hideLoading()
              }, 1000)

            })
          })
        }
      },
      addFilmToCurrentList: function (filmID) {
        let vm = this
        let $listID = $('#list_select').val()
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var films = doc.data().films
            console.log(films)
            console.log(filmID)
            if ($.inArray(filmID, films) === -1) {
              films.push(filmID)
              listRef.update({
                films: films
              })
              vm.filmIDs = films
              vm.getFilms($listID)
            }
          }
        })
      },
      removeFilmFromList: function (filmID) {
        let vm = this
        let $listID = $('#list_select').val()
        console.log('removeFilmFromList, list: ' + $listID + ', filmID: ' + filmID)
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            var films = doc.data().films
            if ($.isArray(films)) {
              films.splice($.inArray(filmID, films), 1)
              listRef.update({
                films: films
              })
              vm.filmIDs = films
              vm.films = []
              vm.getFilms($listID)
            }
          }
        })
      },
      updateList: function (filmIDs) {
        let vm = this
        let $listID = $('#list_select').val()
        let listRef = db.collection('lists').doc($listID)
        listRef.get().then(function (doc) {
          if (doc.exists) {
            listRef.update({
              films: filmIDs
            }).then(function() {
              console.log("List films successfully updated!");
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });
            console.log('updatedGrapeList')
          }
        })
      },
      afterRowMoveHandler: function (rows, target) {
        let vm = this
        let data = this.$refs.filmsTable.table.getData()
        let revisedfilmIDs = []
        for (let i = 0; i < data.length; i++) {
          let filmID = data[i][0]
          revisedfilmIDs.push(filmID) 
        }
        vm.updateList(revisedfilmIDs)
      }
    },
    mounted () {
      let $vue = this
      $(document).on('click', '.remove-film', function () {
        $vue.removeFilmFromList($(this).data('id'))
        return false
      })
    }
  };
</script>

<style>
  #matrix-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 80px);
    margin-top: 4px;
    overflow: hidden;
  }
  #matrix-table th {
    vertical-align: middle;
  }
  #matrix-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #matrix-table thead th .relative {
    padding: 4px 8px;
  }
  .ais-index form {
    position: relative;
  }
  .ais-index form button {
    position: absolute;
    top: 0;
    right: 0;
    height: 36px;
    width: 36px;
  }
  .ais-index form button[type="submit"] {
    right: 36px;
  }
  .ais-highlight em {
    text-decoration: underline;
    font-weight: bold;
  }
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  .input-field {
    position: relative;
    margin-bottom: 20px;
  }
  .add-list-trigger {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -9px;
    cursor: pointer;
  }
  .add-list-trigger i.fa-circle-notch {
    display: none;
  }
  .add-list-trigger.is-adding i {
    display: none;
  }
  .add-list-trigger.is-adding i.fa-circle-notch {
    display: inline-block;
  }
  .list-wrap {
    text-align: left;
    max-width: 96%;
    margin: 0 auto 100px;
  }
  .list-wrap .pure-form label {
    font-weight: bold;
    line-height: 30px
  }
  .list-wrap .pure-form select, .list-wrap .pure-form input {
    width: 100%;
  }
  .list-wrap form input[type="search"] {
    line-height: 30px;
    width: 100%;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .list-actions {
    padding-right: 20px;
    box-sizing: border-box;
  }
  .list-actions h4 {
    border-bottom: 1px solid #2c3e50;
    padding: 0 0 4px;
    margin: 30px 0 20px;
    line-height: 30px;
  }
  .grape-results {
    padding-left: 20px;
    box-sizing: border-box;
  }
  .ais-results {
    font-size: 0.8em;
    width: 100%;
    display: table-row-group;
  }
  .ais-results > div {
    display: table-row;
  }
  .ais-results:hover > div {
    opacity: 0.5;
  }
  .ais-results > div:hover {
    opacity: 1;
    cursor: pointer;
  }
  .grape-result .director {
    padding: 10px 15px 10px 0;
    float: left;
    width: 35%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .grape-result .year {
    padding: 10px 15px 10px 0;
    float: left;
    width: 20%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .grape-result > span {
    padding: 10px 0;
    float: left;
    width: 45%;
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
  }
  .table-wrap {
    max-width: 100%;
    margin: 0 auto;
  }
  #grapes-table {
    width: 100%;
    height: 800px;
    margin-top: 4px;
    overflow: hidden;
  }
  #grapes-table th {
    vertical-align: middle;
  }
  #grapes-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grapes-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/FilmList.vue